import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"loading":_vm.loading,"items":_vm.availableResource,"label":_vm.$attrs.label || _vm.$t('Resource'),"outlined":"","hide-details":"auto"},model:{value:(_vm.resource),callback:function ($$v) {_vm.resource=$$v},expression:"resource"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }